import { useTranslation } from '../context/TranslationContext';
import { translateWithFallback } from '../utils/translateWithFallback';

const Blog = () => {
    const { t } = useTranslation();
    const tr = (key: string, fallback: string) => translateWithFallback(t, key, fallback);

    const posts = [
        {
            titleKey: 'page.blog.post1.title',
            titleFallback: '5 essentials for your Belgian nursery on a budget',
            excerptKey: 'page.blog.post1.excerpt',
            excerptFallback: 'From second-hand Moses baskets to EU-safe sleep guidelines — what Flemish and Walloon parents really need.',
            dateKey: 'page.blog.post1.date',
            dateFallback: 'June 2026',
        },
        {
            titleKey: 'page.blog.post2.title',
            titleFallback: 'Circular parenting: why pre-loved beats new',
            excerptKey: 'page.blog.post2.excerpt',
            excerptFallback: 'How buying and selling on Petito keeps tonnes of baby gear out of landfill each year in Belgium.',
            dateKey: 'page.blog.post2.date',
            dateFallback: 'May 2026',
        },
        {
            titleKey: 'page.blog.post3.title',
            titleFallback: 'Car seat safety checklist for EU parents',
            excerptKey: 'page.blog.post3.excerpt',
            excerptFallback: 'i-Size, expiry dates, and what to check before buying a used car seat in Belgium.',
            dateKey: 'page.blog.post3.date',
            dateFallback: 'April 2026',
        },
    ];

    return (
        <div className="mx-auto max-w-4xl py-6 text-[var(--text-color)] sm:py-8">
            <header className="mb-8 sm:mb-10">
                <h1 className="mb-2 text-2xl font-bold sm:text-3xl">{tr('page.blog.title', 'Petito Blog')}</h1>
                <p className="text-base opacity-80 sm:text-lg">{tr('page.blog.subtitle', 'Tips, guides, and stories for Belgian parents — coming soon.')}</p>
            </header>

            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {posts.map((post) => (
                    <article
                        key={post.titleKey}
                        className="rounded-2xl border border-[color-mix(in_srgb,var(--accent-color),transparent_60%)] bg-[color-mix(in_srgb,var(--bg-color),white_15%)] backdrop-blur-sm p-6 shadow-sm hover:shadow-md transition-shadow"
                    >
                        <time className="text-sm opacity-60">{tr(post.dateKey, post.dateFallback)}</time>
                        <h2 className="text-xl font-semibold mt-2 mb-3">{tr(post.titleKey, post.titleFallback)}</h2>
                        <p className="text-sm leading-relaxed opacity-85">{tr(post.excerptKey, post.excerptFallback)}</p>
                        <span className="inline-block mt-4 text-sm font-medium text-[var(--text-color)] opacity-60">
                            {tr('page.blog.comingsoon', 'Full article coming soon')}
                        </span>
                    </article>
                ))}
            </div>
        </div>
    );
};

export default Blog;